// extracted by mini-css-extract-plugin
module.exports = {"welcomeScreenWrapper":"WelcomeScreen_welcomeScreenWrapper__2yhr6","wrapTitle5":"WelcomeScreen_wrapTitle5__x_bnr"};